import { Moment } from 'moment';
import momentTz from 'moment-timezone';
import { ValidDateRange } from './types';
import { ValidDateRange as NewValidDateRange } from './calendar/types';

/**
 * converts the old (moment) date range to the new date range
 * used by the new ui/calendar type
 */
export const convertValidDateRange = (
  momentDateRange?: ValidDateRange,
): NewValidDateRange | undefined => {
  if (!momentDateRange) {
    return undefined;
  }

  return {
    startDate: momentDateRange.start?.format(),
    endDate: momentDateRange.end?.format(),
  };
};

/**
 * converts a moment object to a date string.
 * output remains the input if a string (the date as a string) is provided instead.
 */
export const convertMomentToDateString = (
  date: Moment | null | string,
  timeZone?: string | null,
) => {
  // the date picker can start of with an "undefined" state where no date is selected.
  // the calendar does not support this. so we need to show something as being selected,
  // so we default to the current date.
  if (date === null) {
    return timeZone ? momentTz.tz(timeZone).format('YYYY-MM-DD') : momentTz().format('YYYY-MM-DD');
  }

  if (typeof date === 'string') {
    return date;
  }

  return timeZone
    ? momentTz(date?.format()).tz(timeZone).format('YYYY-MM-DD')
    : date?.format('YYYY-MM-DD');
};
